import { images } from './ImageUrls';

const related_post_979 = {
  heading: 'RELATED ARTICLES',
  posts: [
    {
      id: 139788,
      content_type: 'Article',
      content: {
        title: 'Stretch Marks: Why do They Appear and How to Get Rid of Them?',
        web_url: '/article/how-to-remove-stretch-marks-139788',
        body: 'It is common to have stretch marks! Nearly all women get stretch marks during pregnancy...',
        webpImages: images.relatedArticle1,
      },
    },
    {
      id: 25171,
      content_type: 'Article',
      content: {
        title: 'How to get rid of Pregnancy Stretch marks easily?',
        web_url:
          '/article/how-to-get-rid-of-pregnancy-stretch-marks-easily-25171',
        body: 'Neither you nor your body remains the same after giving birth to your baby. While the apple of your eye becomes the center of your life and makes you more responsible than ever...',
        webpImages: images.relatedArticle13,
      },
    },
    {
      id: 25324,
      content_type: 'Article',
      content: {
        title:
          '7 Important Things Every Woman Must Do in the Second Trimester of her Pregnancy',
        web_url:
          '/article/7-important-things-every-woman-must-do-in-the-second-trimester-of-her-pregnancy-25324',
        body: 'The period of weeks 13-27 of pregnancy is known as the second trimester of your pregnancy. Your baby grows faster and stronger during this phase and your baby bump becomes visible....',
        webpImages: images.relatedArticle7,
      },
    },
  ],
};
const related_post_968 = {
  heading: 'RELATED ARTICLES',
  posts: [
    {
      id: 12925,
      content_type: 'Article',
      content: {
        title:
          'Cloth Vs Disposable: Which Diaper Is Best For Your Newborn, Has The Answer To Everything',
        web_url: '/article/cloth-diapers-vs-disposable-diapers-12925',
        body: 'Congratulations on your pregnancy. So, have you prepared your baby shopping list? Do not forget to list diapers on top of it. Here is why...',
        webpImages: images.relatedArticle2,
      },
    },
    {
      id: 72606,
      content_type: 'Article',
      content: {
        title:
          'Top 5 Benefits of Making Your Baby Wear Free Size Reusable Cloth Diapers',
        web_url:
          '/article/top-5-benefits-of-making-your-baby-wear-free-size-reusable-cloth-diapers-72606',
        body: 'Disposable diapers make your life hassle-free. Instead of cleaning up the baby&rsquo;s big poopy messes, you can throw it in the garbage bin, and you are done. But disposable diapers are not only expensive, they also create huge landfill waste...',
        webpImages: images.relatedArticle8,
      },
    },
    {
      id: 73725,
      content_type: 'Article',
      content: {
        title:
          'How can reusable cloth diapers help in preventing diaper rashes in your baby?',
        web_url:
          '/article/how-can-reusable-cloth-diapers-help-in-preventing-diaper-rashes-in-your-baby-73725',
        body: 'Free size reusable cloth diapers are beneficial by all accounts as they are cost-efficient, eco-friendly, reusable, and breathable. By maintaining proper hygiene and care, cloth diapers ....',
        webpImages: images.relatedArticle3,
      },
    },
  ],
};
const related_post_1119 = {
  heading: 'RELATED ARTICLES',
  posts: [
    {
      id: 72680,
      content_type: 'Article',
      content: {
        title:
          'At what age should you stop using a baby carrier for your little one?',
        web_url:
          '/article/at-what-age-should-you-stop-using-a-baby-carrier-for-your-little-one-72680',
        body: 'Being a parent is a full-time job. You need to attend to your baby all the time while carrying out your other responsibilities. It can be frustrating and tiring, but you can neither compromise...',
        webpImages: images.relatedArticle12,
      },
    },
    {
      id: 72678,
      content_type: 'Article',
      content: {
        title:
          '5 qualities to look for while selecting a baby carrier for your little One',
        web_url:
          '/article/5-qualities-to-look-for-while-selecting-a-baby-carrier-for-your-little-one-72678',
        body: 'When it comes to the best baby carrying tool, Baby Carrier wins the competition hands down. Strollers and prams are good, but they come with their own limitations. In comparison, baby carriers offer innumerable benefits...',
        webpImages: images.relatedArticle5,
      },
    },
    {
      id: 73082,
      content_type: 'Article',
      content: {
        title:
          '5 dangerous mistakes every parent should avoid while carrying the baby in a baby carrier ',
        web_url:
          '/article/5-dangerous-mistakes-every-parent-should-avoid-while-carrying-the-baby-in-a-baby-carrier-73082',
        body: 'Baby carrier adds a lot of convenience in your life. This parenting gear allows you to keep your baby close as you work, shop, travel, or navigate through the crowded streets ....',
        webpImages: images.relatedArticle6,
      },
    },
  ],
};
const related_post_11 = {
  heading: 'RELATED ARTICLES',
  posts: [
    {
      id: 25204,
      content_type: 'Article',
      content: {
        title: 'Top 5 Useful Tips to help You Sleep Better During Pregnancy',
        web_url:
          '/article/top-5-useful-tips-to-help-you-sleep-better-during-pregnancy-25204',
        body: 'Although most women feel a lot better during the second trimester with the decrease in nausea and fatigue, you may suffer from a few minor sleep issues....',
        webpImages: images.relatedArticle4,
      },
    },
    {
      id: 25326,
      content_type: 'Article',
      content: {
        title:
          "Your sleeping pattern during pregnancy may vary from others. But there's a reason to it...",
        web_url:
          'article/your-sleeping-pattern-during-pregnancy-may-vary-from-others-but-theres-a-reason-to-it-25326',
        body: 'Pregnancy is one of the most beautiful phases in a woman’s life but it comes with its own share of anxieties and problems. This is the time when most of the pregnant...',
        webpImages: images.relatedArticle12,
      },
    },
    {
      id: 25351,
      content_type: 'Article',
      content: {
        title: 'Top tips to help you sleep better during pregnancy ',
        web_url:
          '/article/top-tips-to-help-you-sleep-better-during-pregnancy-25351',
        body: "It's hard to sleep when you have a bulging belly, but also so important. When you are pregnant, it is common to have sleep pattern disturbances ....",
        webpImages: images.relatedArticle9,
      },
    },
    {
      id: 25455,
      content_type: 'Article',
      content: {
        title: 'Important tips for you to get a sound sleep during pregnancy',
        web_url:
          '/article/important-tips-for-you-to-get-a-sound-sleep-during-pregnancy-25455',
        body: 'Getting a sound sleep during pregnancy seems impossible. The bigger your belly gets, the more the comfort tosses away. Your baby starts to kick strongly ....',
        webpImages: images.relatedArticle10,
      },
    },
  ],
};

export const relatedPostsPDP = {
  979: related_post_979, //Stretch Marks- Day & Night Kit - Oil (100 ml) & Cream (100 gm)
  968: related_post_968, //Free Size Reusable Cloth Diaper with Absorbent Insert Pad (3 - 36 Months) - Celebration Print
  1119: related_post_1119, //Premium Baby Carrier with Head Support & Adjustable Buckle Straps (6 - 24 Months) - Royal Blue
  738: related_post_1119, //Premium Baby Carrier with Head Support & Adjustable Buckle Straps (6 - 24 Months) - Red
  1120: related_post_1119, //Premium Baby Carrier with Head Support & Adjustable Buckle Straps (6 - 24 Months) - Grey
  11: related_post_11, //Pregnancy & Maternity Pillow for Sleeping, Belly & Back Support with Washable Zippered Cover - Steel Grey
};
